export class LayoutActions {
  static readonly SIDE_NAV_TOGGLE = '[LAYOUT] SIDE_NAV_TOGGLE';
  static readonly SET_TILE = '[LAYOUT] SET_TILE';
}

